import Token from '@/services/token'
import { formatErrors } from '@utils/errors-alert'
import { bus } from '@/plugins/event-bus'

const saveToken = (context, payload) => {
  const { token } = payload
  const tenantAuthenticationToken = { payer_id: token.payer_id, request_host: token.request_host }

  return new Promise(async(resolve, reject) => {
    Token.save(tenantAuthenticationToken).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

const removeToken = (context, payload) => {
  return new Promise(async(resolve, reject) => {
    Token.remove(payload.data.id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

export default {
  saveToken,
  removeToken
}



// WEBPACK FOOTER //
// ./src/features/tokens/store/actions.js